import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from './Section.module.css';

import { useAppDispatch, useAppSelector } from '../../hooks/useRedux';
import { menuChanged } from '../../features/infoSlice';

import Slider from '../Slider';
import EmptyContent from './EmptyContent';
import {
  LibraryList,
  Menu,
  ResourceList,
  SharedLibraryList,
} from '../../types/main';
import { useAddMenuHistoryMutation } from '../../services/main';
import { NAVIGATION_MENU_MAP } from '../../constants';
import { useEffect, useState } from 'react';
import { selectMenuList } from '../../features/mainSlice';
import { StringByKey } from '../../types/common';

interface Section {
  name: string;
  title: string;
  data: LibraryList | SharedLibraryList | ResourceList;
}

const nameList: StringByKey = {
  personalList: 'library',
  shareList: 'share',
  archiveList: 'mydrive',
};

export default function Section({ name, title, data }: Section) {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();
  const menuList = useAppSelector(selectMenuList);
  const menuName = nameList[name];
  const [menu, setMenu] = useState<Menu>({ cd: '', nm: '' });

  const ContentComponent = data.length ? Slider : EmptyContent;
  const slicedData = data.slice(0, 12);

  const [addMenuHistory] = useAddMenuHistoryMutation();

  const moveMenu = async () => {
    dispatch(menuChanged(menuName));
    try {
      await addMenuHistory({ cd: menu.cd });
    } catch (error) {
      console.error('Failed to Add Menu History', error);
    }
  };

  useEffect(() => {
    if (menuList) {
      const menu = menuList.find(
        ({ nm }) => nm === NAVIGATION_MENU_MAP[menuName]
      );
      menu && setMenu(menu);
    }
  }, [menuList]);

  return (
    <div className={cx('section')}>
      <h2>
        <i className={cx(`tit_ico_${menuName}`)}></i>
        <Link to={menuName} onClick={moveMenu}>
          {title}
        </Link>
      </h2>
      <ContentComponent name={menuName} list={slicedData} />
    </div>
  );
}
